import { useContext, useEffect, useRef, useState } from "react";
import Button from "../buttons/Button";
import FileUpload from "../input/FileUpload";
import Input from "../input/Input";
import Select from "../select/Select";
import { appContext } from "../../service/AppContext";
import { registrationContex } from "../../service/RegisrationContext";
import Checkbox from "../input/Checkbox";
import { server, resourceId } from '../standingOrderSelector/BankStandingOrder'
import { useFetch } from "../../service/useFetch";

export default function BankInfoForm({ onCompleted, banks }) {

    // const [bankInfo,setBankInfo]
    const { user, setFetch } = useContext(appContext);
    const { donor } = useContext(registrationContex);
    const [selectedBank, setSelectedBank] = useState();
    const [selectedBranch, setSelectedBranch] = useState();
    const [branchOptions, setBranchOptions] = useState();
    const [billingDay, setBillingDay] = useState('');

    const formRef = useRef()

    // const { data } = useFetch(`/datastore_search?resource_id=${resourceId}&distinct=true&fields=Branch_Code%2CBranch_Name&sort=Branch_Name&include_total=false`, { server: server, });
    const { data, isPending, setFetch: setFechBracnch } = useFetch('', { server: server });
    useEffect(() => {
        if (data?.result?.records) {
            setBranchOptions(data.result.records.map(branch => ({ value: String(branch.Branch_Code), label: `${branch.Branch_Code} - ${branch.Branch_Name}` })))
        }
    }, [data?.result?.records])

    useEffect(() => {
        if (selectedBank) {
            setSelectedBranch(null);
            setBranchOptions(null);
            setFechBracnch({
                route: `/datastore_search?resource_id=${resourceId}&distinct=true&fields=Branch_Code%2CBranch_Name&sort=Branch_Name&include_total=false&limit=500&filters={"Bank_Code":"${selectedBank}"}`,
                options: { server: server }
            })
        }
    }, [selectedBank, setFechBracnch])



    const handleSubmit = (e) => {
        e.preventDefault();

        const formElement = formRef.current;
        const isValid = formElement.checkValidity();

        formElement.classList.add('submitted');

        const firstInvalidField = formElement.querySelector(":invalid");
        firstInvalidField?.focus();

        if (isValid) {
            const dataObject = new FormData(formElement);
            if (user?.id)
                dataObject.append('id', user?.id);
            setFetch({
                route: '/bank-info', options: {
                    method: 'POST',
                    body: dataObject
                }
            })
            if (typeof (onCompleted) === 'function')
                onCompleted(e);
        }
    }

    return (
        <form ref={formRef} noValidate>
            <div>
                <h4>הנחיות לפתיחת הרשאה באופן עצמאי בבנק</h4>
                <ul>
                    <li>יש לפתוח הרשאה לא מוגבלת בסכום או בתאריך, לקוד מוסד 38717 - הגמ״ח לבית ישראל.</li>
                    <li>יש למלא את פרטי הבנק ולצרף אסמכתא של הקמת הו״ק</li>
                </ul>
            </div>
            <div className='bank-info-fields'>
                <div className="fields-flex">
                    <Select label='שם ומספר בנק' name='bank' required options={banks} onChange={setSelectedBank} value={selectedBank} loading={!banks}>
                        {/* {banks?.bank_options?.map(bank => <option key={bank.value} value={bank.value} >{bank.label}</option>)} */}
                    </Select>
                    <Select label='שם ומספר סניף' name='branch' required options={branchOptions} locked={!selectedBank} value={selectedBranch} onChange={setSelectedBranch} loading={isPending}>
                        {/* {banks?.branch_options?.map(bank => <option key={bank.value} value={bank.value} >{bank.label}</option>)} */}
                    </Select>
                </div>
                <div className="fields-flex">
                    <Input type="number" label='מספר חשבון' name="bank-acount" required />
                    <Input label='שם בעל החשבון ' name='owner-name' required />
                    <Select className="biling-day" name='biling-day' label='תאריך בחודש לחיוב' onChange={setBillingDay} value={billingDay} required placeholder='בחרו יום בחודש' options={[1, 5, 10, 15, 20, 25]} />
                    <div className="field-wrapper biling-day"></div>
                </div>
                <FileUpload label='צירוף אסמכתא של הקמת הו"ק' name='attachment' />
                {(donor?.isMember) && <Checkbox name='update-apt-payment-method' label='עדכן גם את אמצעי התשלום הנוכחי לגמ"ח (אם קיים) לאמצעי זה' value="update-payment" />}

            </div>
            <Button type='button' onClick={handleSubmit} size='small' label='אישור וסיום' />
        </form>)
}